<template>
  <MaintenanceVue v-if="this.$store.maintenanceMode" />
  <div class="cb-landing" v-else>
    <div class="cb-landing__img-container">
      <img
        alt="ADT Cellbridge Device"
        src="../assets/images/cellbridge-device.png"
        v-if="screenSize === 'desktop'"
      />
    </div>
    <div class="cb-landing__container">
      <div class="cb-landing__container__logo">
        <img alt="ADT Logo" src="../assets/icons/myadt-logo.svg" />
      </div>
      <div class="cb-landing__container__content">
        <component :is="loginStep"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Welcome from '../components/Welcome.vue';
import Login from '../components/Login.vue';
import AltLogin from '../components/AltLogin.vue';
import MaintenanceVue from '../components/Maintenance.vue';

export default {
  beforeMount() {
    this.setLoginStep(this.$route.name);
  },

  methods: {
    setLoginStep(routeName) {
      if (routeName === 'Welcome') {
        this.updateLoginStep('cbWelcome');
      } else {
        this.updateLoginStep('cbLogin');
      }
    },
    ...mapMutations(['updateLoginStep']),
  },
  watch: {
    $route(to) {
      this.setLoginStep(to.name);
    },
  },
  computed: {
    ...mapState({
      loginStep: (state) => state.loginStep,
      screenSize: (state) => state.screenSize,
      maintenanceMode: (state) => state.maintenanceMode,
    }),
  },
  components: {
    cbWelcome: Welcome,
    cbLogin: Login,
    cbAltLogin: AltLogin,
    MaintenanceVue,
  },
};
</script>

<style lang="scss" scoped>
.cb-landing {
  &__img-container {
    display: none;
  }

  &__container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: white;

    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $azure;
      min-height: 158px;

      img {
        height: 79px;
      }
    }

    &__content {
      width: 100%;
      max-width: 430px;
      flex-grow: 1;
      margin: 0 auto;
    }
  }

  @include desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    width: 100vw;
    padding: 20px;
    box-sizing: border-box;

    &__img-container {
      display: block;
      height: 678px;
      width: 557px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    &__container {
      width: 430px;
      height: 678px;
      max-height: 678px;

      &__content {
        height: 520px;
        margin: 0;
      }
    }
  }
}
</style>
